export default __webpack_public_path__ + "static/media/blog-img248.11e6b96a.jpg";